import React from 'react';
import { Clock } from 'lucide-react';

interface TimePickerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export default function TimePicker({ label, value, onChange, className = '' }: TimePickerProps) {
  return (
    <div className={`bg-gray-50 rounded-xl px-4 ${className}`}>
      <div className="flex items-center space-x-2">
        <label className="font-medium text-gray-900">{label}</label>
      </div>
      
      <div className="space-y-2">
        <input
          type="time"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-400 focus:border-transparent"
        />
      </div>
    </div>
  );
}